import { render, staticRenderFns } from "./PureActivityBoard.vue?vue&type=template&id=96e452a8&scoped=true"
import script from "./PureActivityBoard.vue?vue&type=script&lang=js"
export * from "./PureActivityBoard.vue?vue&type=script&lang=js"
import style0 from "./PureActivityBoard.vue?vue&type=style&index=0&id=96e452a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e452a8",
  null
  
)

export default component.exports